import { CmBox, CmHeading, CmStack } from '@/components/uiParts';
import { OrderMethodDisplayNameSettingFormSubItem } from '@/pages/camel-order/sites/components/OrderMethodDisplayNameSettingFormSubItem';
import { Site } from '@/pages/camel-order/sites/service';
import { FormError } from '@/validate';

import {
  HandleChangeIsCustomOrderTypeDisplayName,
  HandleChangeOrderTypeDisplayName,
} from './type';

type Props = {
  label: string;
  custom_order_method_text: Site['custom_order_method_text'];
  handleChangeIsCustomOrderTypeDisplayName: HandleChangeIsCustomOrderTypeDisplayName;
  handleChangeOrderTypeDisplayName: HandleChangeOrderTypeDisplayName;
  orderTypeDisplayNameByTakeoutText: FormError;
  orderTypeDisplayNameByTakeoutButtonText: FormError;
  orderTypeDisplayNameByEatInText: FormError;
  orderTypeDisplayNameByEatInButtonText: FormError;
  orderTypeDisplayNameByDeliveryText: FormError;
  orderTypeDisplayNameByDeliveryButtonText: FormError;
};

export const OrderMethodDisplayNameSettingFormItem: React.FC<Props> = (
  props
) => {
  const { delivery, eat_in, takeout } = props.custom_order_method_text;
  const {
    label,
    handleChangeIsCustomOrderTypeDisplayName,
    handleChangeOrderTypeDisplayName,
  } = props;

  return (
    <CmBox mt="30px">
      <CmHeading fontSize="18px" pb="10px">
        {label}
      </CmHeading>
      <CmBox pl="20px">
        <CmStack direction="column" spacing="4">
          <OrderMethodDisplayNameSettingFormSubItem
            method="takeout"
            methodData={takeout}
            handleChangeIsCustomOrderTypeDisplayName={
              handleChangeIsCustomOrderTypeDisplayName
            }
            handleChangeOrderTypeDisplayName={handleChangeOrderTypeDisplayName}
            textError={props.orderTypeDisplayNameByTakeoutText}
            buttonTextError={props.orderTypeDisplayNameByTakeoutButtonText}
          />
          <OrderMethodDisplayNameSettingFormSubItem
            method="eat_in"
            methodData={eat_in}
            handleChangeIsCustomOrderTypeDisplayName={
              handleChangeIsCustomOrderTypeDisplayName
            }
            handleChangeOrderTypeDisplayName={handleChangeOrderTypeDisplayName}
            textError={props.orderTypeDisplayNameByEatInText}
            buttonTextError={props.orderTypeDisplayNameByEatInButtonText}
          />
          <OrderMethodDisplayNameSettingFormSubItem
            method="delivery"
            methodData={delivery}
            handleChangeIsCustomOrderTypeDisplayName={
              handleChangeIsCustomOrderTypeDisplayName
            }
            handleChangeOrderTypeDisplayName={handleChangeOrderTypeDisplayName}
            textError={props.orderTypeDisplayNameByDeliveryText}
            buttonTextError={props.orderTypeDisplayNameByDeliveryButtonText}
          />
        </CmStack>
      </CmBox>
    </CmBox>
  );
};
